import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { ICCOrderTableReport } from "src/Interfaces/ccOrder";
import { setCCOrderOrderTableFetchDataFlag } from "src/Features/CCOrder/ccOrderSlice";

const TableUI: React.FC<ITableUI<ICCOrderTableReport>> = (
  props: ITableUI<ICCOrderTableReport>,
) => {
  const orderTableFetchDataFlag = useAppSelector(
    (store) => store.ccOrder.orderTableFetchDataFlag,
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!!orderTableFetchDataFlag && props.onAction) {
      dispatch(setCCOrderOrderTableFetchDataFlag(false));
      props.onAction();
    }
  }, [orderTableFetchDataFlag]);

  return <CommonTableUI {...props} refreshFlag={orderTableFetchDataFlag} />;
};

export default TableUI;
